import { useTranslation } from "react-i18next";

const SuccessScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white px-2 py8 min-h-[100%] flex-1">
      <h2 className="text-2xl mt-12 mb-2 text-center font-black uppercase">
        {t("success.title")}
      </h2>

      <p
        className="text-dark-blue text-center px-8 mb-[60px]"
        dangerouslySetInnerHTML={{ __html: t("success.message") }}
      />

      <p
        className="text-center mt-4 text-[14px] font-semibold leading-[20px] max-w-[350px] mx-auto"
        dangerouslySetInnerHTML={{
          __html: t("success.instagram", { br: "<br/>" }),
        }}
      />

      <a
        className="w-[280px] bg-blue text-white text-xl h-[60px] rounded-[5px] font-semibold flex justify-center items-center mx-auto mt-[15px] px-[30px] py-[15px] gap-2"
        href="https://www.instagram.com/ford_evroadtrip/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/img/instagram.svg" alt="instagram logo" />
        @ford_evroadtrip
      </a>
    </div>
  );
};

export default SuccessScreen;
